import { defineComponent as _defineComponent } from 'vue'
import { drillDefaultData, tempDefaultStr } from '@/util/defaultTagData'
import { computed, ref, watch } from 'vue'
import Vue from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'dockFiveSixSample',
  props: {
    fileType: null,
    ariMachine: { type: Boolean },
    modelSetting: null,
    isDoorWallAio: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fileType: string
  ariMachine?: boolean
  modelSetting?: object
  isDoorWallAio?: boolean
}


// 接口数据
const formData = ref<any>({})
// 需要检查重新赋值的key
const checkKey = ['{生成轮廓序号}', '{圆弧方向}', '{生成孔槽序号}'] as const
// 不需要请求的key
const noRequestFileType = [
  'ban',
  'dxf',
  'xml2',
  'mpr',
  'xinhongtian',
  'pinmai',
  'ruinuo',
  'kaihong',
  'jidong',
  'nanxingfeida',
]

const sampleDataStr = computed(() => {
  const { fileType } = props
  let showText = ''
  //   不需要请求接口的样例 则取默认样例
  if (noRequestFileType.includes(fileType)) {
    return tempDefaultStr[
      `${fileType}`.toLocaleUpperCase() as keyof typeof tempDefaultStr
    ]
  }
  if (
    props.isDoorWallAio
      ? !formData.value.model_setting
      : !formData.value.file_setting
  )
    return
  const copyData = JSON.parse(JSON.stringify(drillDefaultData))

  //   初始化模板数据的值
  if (!props.ariMachine) {
    initTagTempData(
      copyData,
      props.isDoorWallAio
        ? formData.value?.model_setting
        : formData.value?.file_setting
    )
  }
  const { code_list, no_auto_new_line } = !props.ariMachine
    ? props.isDoorWallAio
      ? formData.value?.model_setting
      : formData.value?.file_setting
    : formData.value
  //   更新模板数据展示
  code_list.forEach((code: any) => {
    let {
      code: { template_string },
    } = code
    // 替换匹配到的字符
    template_string = template_string.replace(
      /\{[^}]+\}/g,
      (key: keyof typeof copyData) => copyData[key]
    )
    showText += no_auto_new_line ? template_string : template_string + '\n'
  })
  return showText
})
// 初始化tag模板数据
function initTagTempData(tempData: typeof drillDefaultData, fileSetting: any) {
  // 更新模板的数据
  const update = (key: keyof typeof drillDefaultData, value: any) =>
    value && (tempData[key] = value)

  for (const key of checkKey) {
    switch (key) {
      case '{生成轮廓序号}':
        update(key, fileSetting.start_num)
        break
      case '{生成孔槽序号}':
        update(key, fileSetting.hole_slot_start_num)
        break
      case '{圆弧方向}':
        update(key, fileSetting.curve_direction_settings.concave)
        break
      default:
        const neverValue: never = key
        return neverValue
    }
  }
}

// 监听改变请求数据
watch(
  () => props.fileType,
  (n) => {
    if (noRequestFileType.includes(n)) return
    if (props.ariMachine) {
      formData.value = props.modelSetting
      if (!formData.value.code_list) return '错误! 未能获取到模板数据'
    } else {
      Vue.prototype.$getByToken(
        props.isDoorWallAio ? '/door_wall_aio_model' : '/load_dock56F_model',
        { id: n },
        (res: any) => {
          if (res.status) formData.value = res.data
          if (
            !props.isDoorWallAio
              ? formData.value?.file_setting
              : formData.value?.model_setting
          )
            return '错误! 未能获取到模板数据'
        }
      )
    }
  },
  { immediate: true }
)

return { __sfc: true,props, formData, checkKey, noRequestFileType, sampleDataStr, initTagTempData }
}

})